(() => {
  if (window.__motechHalloweenPumpkins) return;
  window.__motechHalloweenPumpkins = true;

  const scene = document.querySelector("[data-seasonal-halloween-scene]");
  const header = document.querySelector("store-header.header");
  const canvas = scene?.querySelector("[data-seasonal-halloween-canvas]");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

  if (!(scene instanceof HTMLElement) || !(header instanceof HTMLElement)) return;
  if (!(canvas instanceof HTMLCanvasElement) || reducedMotion.matches) return;

  const context = canvas.getContext("2d");
  if (!context) return;

  const configuredCount = Number.parseInt(scene.dataset.pumpkinCount || "12", 10);
  const pumpkinColor = scene.dataset.pumpkinColor || "#f47a1f";
  const pumpkinShadowColor = scene.dataset.pumpkinShadowColor || "#9f3210";
  const pointer = { x: -1000, y: -1000, active: false, radius: 72 };
  const pumpkins = [];
  let width = 0;
  let height = 0;
  let pixelRatio = 1;
  let animationFrame = 0;
  let lastTime = performance.now();

  const randomBetween = (minimum, maximum) => minimum + Math.random() * (maximum - minimum);

  const resetPumpkin = (pumpkin, fromTop = false) => {
    const mobile = width < 741;
    pumpkin.radius = randomBetween(mobile ? 7 : 10, mobile ? 12 : 17);
    pumpkin.x = randomBetween(pumpkin.radius, Math.max(pumpkin.radius, width - pumpkin.radius));
    pumpkin.y = fromTop ? randomBetween(-height * 0.8, -pumpkin.radius) : randomBetween(-height, height * 0.35);
    pumpkin.vx = randomBetween(-14, 14);
    pumpkin.vy = randomBetween(8, 30);
    pumpkin.angle = randomBetween(0, Math.PI * 2);
    pumpkin.spin = randomBetween(-1.4, 1.4);
    pumpkin.bornAt = performance.now();
  };

  const createPumpkin = () => {
    const pumpkin = {};
    resetPumpkin(pumpkin);
    return pumpkin;
  };

  const resize = () => {
    const bounds = header.getBoundingClientRect();
    width = Math.max(1, bounds.width);
    height = Math.max(1, bounds.height);
    pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(width * pixelRatio);
    canvas.height = Math.round(height * pixelRatio);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

    const count = Math.max(0, Math.min(width < 741 ? Math.ceil(configuredCount * 0.5) : configuredCount, 20));
    while (pumpkins.length < count) pumpkins.push(createPumpkin());
    if (pumpkins.length > count) pumpkins.length = count;
  };

  const drawPumpkin = (pumpkin) => {
    const radius = pumpkin.radius;
    context.save();
    context.translate(pumpkin.x, pumpkin.y);
    context.rotate(pumpkin.angle);
    context.fillStyle = pumpkinShadowColor;
    context.beginPath();
    context.ellipse(0, 0, radius, radius * 0.78, 0, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = pumpkinColor;
    context.beginPath();
    context.ellipse(-radius * 0.38, 0, radius * 0.58, radius * 0.75, 0, 0, Math.PI * 2);
    context.ellipse(radius * 0.38, 0, radius * 0.58, radius * 0.75, 0, 0, Math.PI * 2);
    context.fill();
    context.fillStyle = pumpkinShadowColor;
    context.globalAlpha = 0.45;
    context.beginPath();
    context.ellipse(0, 0, radius * 0.32, radius * 0.76, 0, 0, Math.PI * 2);
    context.fill();
    context.globalAlpha = 1;
    context.fillStyle = "#5f431f";
    context.fillRect(-radius * 0.12, -radius * 0.93, radius * 0.24, radius * 0.33);
    context.restore();
  };

  const separatePumpkins = (first, second) => {
    const deltaX = second.x - first.x;
    const deltaY = second.y - first.y;
    const minimumDistance = first.radius + second.radius;
    const distanceSquared = deltaX * deltaX + deltaY * deltaY;

    if (distanceSquared === 0 || distanceSquared >= minimumDistance * minimumDistance) return;

    const distance = Math.sqrt(distanceSquared);
    const normalX = deltaX / distance;
    const normalY = deltaY / distance;
    const overlap = minimumDistance - distance;
    first.x -= normalX * overlap * 0.5;
    first.y -= normalY * overlap * 0.5;
    second.x += normalX * overlap * 0.5;
    second.y += normalY * overlap * 0.5;

    const relativeVelocity = (second.vx - first.vx) * normalX + (second.vy - first.vy) * normalY;
    if (relativeVelocity >= 0) return;

    const impulse = -relativeVelocity * 0.82;
    first.vx -= impulse * normalX;
    first.vy -= impulse * normalY;
    second.vx += impulse * normalX;
    second.vy += impulse * normalY;
  };

  const updatePumpkin = (pumpkin, delta, now) => {
    pumpkin.vy += 48 * delta;

    if (pointer.active) {
      const deltaX = pumpkin.x - pointer.x;
      const deltaY = pumpkin.y - pointer.y;
      const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY) || 1;
      const reach = pointer.radius + pumpkin.radius;

      if (distance < reach) {
        const force = (1 - distance / reach) * 620 * delta;
        pumpkin.vx += deltaX / distance * force;
        pumpkin.vy += deltaY / distance * force;
        pumpkin.spin += deltaX / distance * 0.05;
      }
    }

    pumpkin.vx *= Math.pow(0.994, delta * 60);
    pumpkin.vy *= Math.pow(0.998, delta * 60);
    pumpkin.x += pumpkin.vx * delta;
    pumpkin.y += pumpkin.vy * delta;
    pumpkin.angle += pumpkin.spin * delta;

    if (pumpkin.x - pumpkin.radius < 0) {
      pumpkin.x = pumpkin.radius;
      pumpkin.vx = Math.abs(pumpkin.vx) * 0.72;
    } else if (pumpkin.x + pumpkin.radius > width) {
      pumpkin.x = width - pumpkin.radius;
      pumpkin.vx = -Math.abs(pumpkin.vx) * 0.72;
    }

    if (pumpkin.y + pumpkin.radius > height) {
      pumpkin.y = height - pumpkin.radius;
      pumpkin.vy = -Math.max(20, Math.abs(pumpkin.vy) * 0.58);
      pumpkin.spin += pumpkin.vx * 0.012;
    }

    if (now - pumpkin.bornAt > randomBetween(7000, 10500) && pumpkin.y > height * 0.45) {
      resetPumpkin(pumpkin, true);
    }
  };

  const animate = (now) => {
    const delta = Math.min((now - lastTime) / 1000, 0.033);
    lastTime = now;
    context.clearRect(0, 0, width, height);

    for (const pumpkin of pumpkins) updatePumpkin(pumpkin, delta, now);

    for (let firstIndex = 0; firstIndex < pumpkins.length; firstIndex += 1) {
      for (let secondIndex = firstIndex + 1; secondIndex < pumpkins.length; secondIndex += 1) {
        separatePumpkins(pumpkins[firstIndex], pumpkins[secondIndex]);
      }
    }

    for (const pumpkin of pumpkins) drawPumpkin(pumpkin);
    animationFrame = requestAnimationFrame(animate);
  };

  const updatePointer = (event) => {
    const bounds = canvas.getBoundingClientRect();
    pointer.x = event.clientX - bounds.left;
    pointer.y = event.clientY - bounds.top;
    pointer.active = pointer.x >= 0 && pointer.x <= bounds.width && pointer.y >= 0 && pointer.y <= bounds.height;
  };

  const clearPointer = () => {
    pointer.active = false;
  };

  const updateVisibility = () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrame);
      animationFrame = 0;
      return;
    }

    if (!animationFrame) {
      lastTime = performance.now();
      animationFrame = requestAnimationFrame(animate);
    }
  };

  header.append(scene);
  scene.hidden = false;
  resize();

  const resizeObserver = new ResizeObserver(resize);
  resizeObserver.observe(header);
  window.addEventListener("pointermove", updatePointer, { passive: true });
  window.addEventListener("pointerout", clearPointer, { passive: true });
  document.addEventListener("visibilitychange", updateVisibility);
  animationFrame = requestAnimationFrame(animate);
})();
